import React, { useEffect, useRef } from 'react'

type NativeModalDialogProps = {
  open: boolean
  onClose: () => void
  className?: string
  children: React.ReactNode
}

/**
 * Native `<dialog>` wrapper: `showModal` when open, backdrop click + Escape → onClose.
 */
export const NativeModalDialog: React.FC<NativeModalDialogProps> = ({ open, onClose, className, children }) => {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (open) {
      if (!el.open) el.showModal()
    } else if (el.open) {
      el.close()
    }
  }, [open])

  return (
    <dialog
      ref={ref}
      className={className}
      onCancel={(e) => {
        e.preventDefault()
        onClose()
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      {children}
    </dialog>
  )
}
